import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const UrgencyTimer = ({ endTime }) => {
  const [timeLeft, setTimeLeft] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(endTime).getTime() - now;

      if (distance < 0) {
        clearInterval(timer);
      } else {
        setTimeLeft({
          h: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          m: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          s: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return (
    <div className="flex items-center gap-2 text-red-500 font-black text-[10px] uppercase tracking-widest bg-red-50 px-3 py-1.5 rounded-full border border-red-100">
      <SafeIcon icon={FiIcons.FiClock} className="animate-pulse" />
      Ends in: {timeLeft.h}h {timeLeft.m}m {timeLeft.s}s
    </div>
  );
};

export default UrgencyTimer;